import { useEffect, useRef, useCallback } from 'react'

const STORAGE_KEY = 'portal-patients-scroll-y'

/**
 * スクロール位置を sessionStorage に保存・復元する hook。
 * @param isReady データ描画完了後に true を渡すと復元が発火する
 */
export const useScrollRestoration = (isReady: boolean) => {
  const hasRestored = useRef(false)

  useEffect(() => {
    if (isReady && !hasRestored.current) {
      const savedY = sessionStorage.getItem(STORAGE_KEY)
      if (savedY) {
        requestAnimationFrame(() => {
          window.scrollTo(0, parseInt(savedY, 10))
        })
        sessionStorage.removeItem(STORAGE_KEY)
      }
      hasRestored.current = true
    }
  }, [isReady])

  const saveScrollPosition = useCallback(() => {
    sessionStorage.setItem(STORAGE_KEY, String(window.scrollY))
  }, [])

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return { saveScrollPosition, scrollToTop }
}
